import { MediumsEnum } from 'features/firebase/Firebase.constants'
import { SwitchboardEndpointsEnum } from 'features/switchboard/Switchboard.types'
import { invert } from 'lodash'

export const SwitchboardMediumsToDeprecatedMediums: Record<
  SwitchboardEndpointsEnum.SMS | SwitchboardEndpointsEnum.WHATSAPP | SwitchboardEndpointsEnum.TELEGRAM,
  MediumsEnum
> = {
  [SwitchboardEndpointsEnum.WHATSAPP]: MediumsEnum.WHATSAPP,
  [SwitchboardEndpointsEnum.TELEGRAM]: MediumsEnum.TELEGRAM,
  [SwitchboardEndpointsEnum.SMS]: MediumsEnum.SMS,
}

export const DeprecatedMediumsToSwitchboardMediums: Record<MediumsEnum, SwitchboardEndpointsEnum> = invert(
  SwitchboardMediumsToDeprecatedMediums
) as Record<
  MediumsEnum,
  SwitchboardEndpointsEnum.SMS | SwitchboardEndpointsEnum.WHATSAPP | SwitchboardEndpointsEnum.TELEGRAM
>

export const SB_PREFIX = 'vf:'
